import React from 'react'
import { Link } from 'react-router-dom'
import IconButtonUI from '../../../../widgets/action/IconButtonUI.js'
import GenericErrorUI from '../../../../components/common/GenericErrorUI.js'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../../components/common/SpinnerComponentUI.js'
import SuperUserSettingsPageUI from '../../../../templates/SuperUserSettingsPageUI.js'
import MasterTemplateNavUI from '../../../../components/superUser/settings/masterTemplates/MasterTemplateNavUI.js'
import MasterLoanAgrNavUI from '../../../../components/superUser/settings/masterTemplates/MasterLoanAgrNavUI.js'
import MasterLoanAgrLoanSpecificNavUI from '../../../../components/superUser/settings/masterTemplates/MasterLoanAgrLoanSpecificNavUI.js'
import MasterLoanAgrGuaranteeNavUI from '../../../../components/superUser/settings/masterTemplates/MasterLoanAgrGuaranteeNavUI.js'
import MasterLoanAgrEscrowNavUI from '../../../../components/superUser/settings/masterTemplates/MasterLoanAgrEscrowNavUI.js'
import MasterTemplateTermSF from '../../../../components/superUser/settings/masterTemplates/MasterTemplateTermSF.js'
import MasterTemplateDownloadModalSF from '../../../../components/superUser/settings/masterTemplates/MasterTemplateDownloadModalSF.js'
import SpinnerUI from '../../../../widgets/output/SpinnerUI.js'

const MasterTemplatePageUI = ({ context, errorList, template, onRefreshClick,
  generateSubmitted, onGenerateTemplatesClick, downloadMode, onDownloadClick, onDownloadCancel,
  templateCode, title, activeTab, navConfig
}) => {
  // navConfig structure: { loanAgrPage, subNavType, subNavPage }
  // Examples:
  // - { loanAgrPage: 'general' } - General terms
  // - { loanAgrPage: 'loanSpecific', subNavType: 'loanSpecific', subNavPage: 'nbfc' } - Loan-specific with sub-nav
  // - { loanAgrPage: 'guarantee', subNavType: 'guarantee', subNavPage: 'pledge' } - Guarantee with sub-nav
  // - { loanAgrPage: 'escrow', subNavType: 'escrow', subNavPage: 'escrow' } - Escrow with sub-nav
  // - null - Standalone agreement (no loan agreement nav)

  const renderSubNav = () => {
    if (!navConfig || !navConfig.subNavType) return null
    
    if (navConfig.subNavType === 'loanSpecific') {
      return <MasterLoanAgrLoanSpecificNavUI page={navConfig.subNavPage} />
    }
    if (navConfig.subNavType === 'guarantee') {
      return <MasterLoanAgrGuaranteeNavUI page={navConfig.subNavPage} />
    }
    if (navConfig.subNavType === 'escrow') {
      return <MasterLoanAgrEscrowNavUI page={navConfig.subNavPage} />
    }
    return null
  }

  return (
    <SuperUserSettingsPageUI context={context} className='pg_su_props' topnav='settings'
      headerText='Master Template Terms' centered={!template} page='ftlTemplate' dimension='w1600'
    >
      {
        (!template) &&
        <SpinnerComponentUI />
      }
      {
        errorList && errorList.length > 0 &&
        <GenericErrorUI error={errorList[0]} />
      }
      {
        template &&
        <div>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <span className='g_m_left_100 g_large'><b>Master Template Terms</b></span>
              </span>
            }
            right={
              activeTab === 'loanAgreement' && (
                <span className='g_flex_h g_text_right'>
                  <SpinnerUI show={generateSubmitted} />
                  <Link to='#' className='g_m_left_50' onClick={onGenerateTemplatesClick}>Generate all templates</Link>
                  <Link to='#' className='g_m_left_100' onClick={onDownloadClick}>View templates</Link>
                </span>
              )
            }
          />

          <MasterTemplateNavUI activeTab={activeTab} />
          {navConfig && navConfig.loanAgrPage ? (
            <>
              <MasterLoanAgrNavUI page={navConfig.loanAgrPage} />
              {navConfig.subNavType ? (
                <>
                  {renderSubNav()}
                  <div className='g_m_bottom_50' />
                </>
              ) : (
                <div className='g_m_bottom_50' />
              )}
            </>
          ) : (
            <div className='g_m_bottom_50' />
          )}

          <MasterTemplateTermSF
            context={context}
            title={title}
            templateCode={templateCode}
            templateTerm={template}
            onRefreshClick={onRefreshClick}
          />

          <MasterTemplateDownloadModalSF
            context={context} downloadMode={downloadMode}
            onCancelClick={onDownloadCancel} onRefreshClick={onRefreshClick}
          />
        </div>
      }
    </SuperUserSettingsPageUI>
  )
}

export default MasterTemplatePageUI
